export default "__VITE_ASSET__BZGfyrka__"